import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const ContentSectionContainer = styled.div`
  margin: 0 auto;
  padding: 2rem;
`;

export const ContentSection = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 2rem;
`;

export const SectionTitle = styled.div`
  margin-bottom: 1rem;
`;

export const CardGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  flex-direction: row;
  gap: 1rem;
`;

export const Icon = styled.div`
  font-size: 24px;
  margin-bottom: 8px;
  color: #007bff;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #6b7280;
`;

export const Count = styled.p`
  font-size: 14px;
  color: #6b7280;
`;

// Persona Details Modal Styles
export const PersonaDetailsModalContent = styled.div`
  padding: 1rem;
  max-height: 70vh;
  overflow-y: auto;
`;

export const PersonaDetailsSection = styled.div`
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

export const PersonaDetailsTitle = styled.h4`
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const PersonaDetailsValue = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.6;
  word-wrap: break-word;
`;

export const PersonaDetailsTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const PersonaDetailsTag = styled.span`
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
  background-color: #eff6ff;
  color: #1e40af;
  border-radius: 12px;
  border: 1px solid #bfdbfe;
`;

export const PersonaDetailsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0 0;
`;

export const PersonaDetailsListItem = styled.li`
  font-size: 0.875rem;
  color: #6b7280;
  padding: 0.25rem 0;
  padding-left: 1rem;
  position: relative;

  &:before {
    content: '•';
    position: absolute;
    left: 0;
    color: #9ca3af;
  }
`;
